/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function(){
  if($(document).find('.ait-collection-slider').length){
  	$(document).find('.ait-collection-slider').slick({
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      prevArrow:'<button class="flickity-prev-next-button previous slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
      nextArrow:'<button class="flickity-prev-next-button next slick-next slick-arrow" aria-label="Previous" type="button" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',          
      adaptiveHeight: true,
      responsive: [
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 3
              }
            },        
            {
              breakpoint: 767,
              settings: {
                centerMode: false,
                slidesToShow: 2
              }
            },        
            {
              breakpoint: 480,
              settings: {
                centerMode: false,
                slidesToShow: 2
              }
            }
          ]
    });
  }
});



$(document).ready(function(){
  if($(document).find('.ait-collection-slider1').length){
  	$(document).find('.ait-collection-slider1').slick({
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      prevArrow:'<button class="flickity-prev-next-button previous slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
      nextArrow:'<button class="flickity-prev-next-button next slick-next slick-arrow" aria-label="Previous" type="button" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',          
      adaptiveHeight: true,
      responsive: [
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 3
              }
            },        
            {
              breakpoint: 767,
              settings: {
                centerMode: false,
                slidesToShow: 2
              }
            },        
            {
              breakpoint: 480,
              settings: {
                centerMode: false,
                slidesToShow: 1
              }
            }
          ]
    });
  }
});